export const clientsWithFloorInfo = ["thepodium", "theslateyard", "wayoflife"];

export const clientsWithSqftInfo = [
  "thepodium",
  "theslateyard",
  "hercurlallsop",
  "packagedliving",
  "vivuskwallsop",
  "urbanandcivicallsop",
  "wayoflife",
];

export const clientsWithAvailableFromOverride = ["thepodium", "theslateyard"];

export const roomTypeLabelConfig: Record<string, string> = {
  thepodium: "Apartment",
  theslateyard: "Apartment",
  hercurlallsop: "House Type",
  packagedliving: "House Type",
  vivuskwallsop: "House Type",
  urbanandcivicallsop: "House Type",
  wayoflife: "Apartment Type",
};

export const clientsWithDateFormatDMY = [
  "hercurlallsop",
  "packagedliving",
  "vivuskwallsop",
  "urbanandcivicallsop",
];

export const featuresLabelConfig: Record<string, string> = {
  hercurlallsop: "House Features",
  packagedliving: "House Features",
  vivuskwallsop: "House Features",
  urbanandcivicallsop: "House Features",
};
